<template>
    <label class="flex-form__field" :class="getInvalidClass('seconds')">
        <div class="flex-form__label">
            Seconds
        </div>

        <input v-model="dataNew.seconds" class="flex-form__input">
    </label>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'action-fire-event',
    mixins: [eventDataMixin],

    data() {
        return {
            schema: {
                seconds: {
                    type: Number,
                    default: 1,
                    required: true,
                },
            },
        };
    },
};
</script>
